import { GET_OFFER, GET_CHILD_OFFER, OFFER_RECEIVED, SEND_QUOTE } from './constants';

export const getOffer = code => ({
  type: GET_OFFER,
  code,
});

export const selectChildOffer = (childOffer) => ({
  type: GET_CHILD_OFFER,
  childOffer,
});



export function offerLoaded(offer) {
  return {
    type: OFFER_RECEIVED,
    offer,
  };
}

export function sendQuote(quote) {
  return {
    type: SEND_QUOTE,
    quote,
  };
}
